var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNfcReaderBold = function SvgIconNfcReaderBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M12 15.48q-1.434 0-2.457-1.023T8.52 12t1.023-2.457Q10.566 8.52 12 8.52t2.457 1.023Q15.48 10.566 15.48 12t-1.023 2.457T12 15.48M12 13q.424 0 .713-.287A.97.97 0 0 0 13 12a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 11a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 12q0 .424.287.713.288.287.713.287m-6.83 8.48a2.56 2.56 0 0 1-1.88-.77 2.56 2.56 0 0 1-.77-1.88V15h2.65v3.83H9v2.65zm9.83 0v-2.65h3.83V15h2.65v3.83q0 1.108-.77 1.88a2.56 2.56 0 0 1-1.88.77zM2.52 9V5.17q0-1.108.77-1.88a2.56 2.56 0 0 1 1.88-.77H9v2.65H5.17V9zm16.31 0V5.17H15V2.52h3.83q1.108 0 1.88.77.77.772.77 1.88V9z"
  })));
};
export default SvgIconNfcReaderBold;